import { createRequestBody } from '@/utils/auth';
import { postJson } from '@/utils/fetchOptions';

import { useMutation } from './useMutation';

interface UseLoginProps {
  email: string;
  first_name?: string;
  account_type?: string;
  target?: string;
  onSuccess?: TypeAny;
}

export type AuthRequestBody = Omit<UseLoginProps, 'onSuccess'>;

export function useLogin({ email, first_name, account_type, target, onSuccess }: UseLoginProps) {
  const {
    isLoading,
    data = {},
    mutate,
    error
  } = useMutation({
    mutationKey: 'authenticate',
    mutationFn: async () =>
      postJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/authenticate/magiclink/send-email`,
        body: createRequestBody(email, first_name, account_type, target)
      }).then((response: TypeAny) => response),
    onSuccess
  });

  return {
    isLoading,
    mutate,
    error,
    data
  };
}
